import { Link } from "react-router-dom";
import { animeList } from "@/mocks/anime";
import AnimeCard from "@/components/feature/AnimeCard";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { useFavorites } from "@/hooks/useFavorites";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Favorites() {
  const { favorites } = useFavorites();
  useDocumentTitle("我的收藏 - 动漫网站", "查看你在动漫网站收藏的动漫资源，收藏状态保存在本地，刷新后依然保留。");

  const items = animeList.filter((a) => favorites.includes(a.id));

  return (
    <div className="mx-auto max-w-[1280px] px-4 md:px-8 py-6 md:py-10">
      <Breadcrumb items={[{ label: "我的收藏" }]} />

      <header className="mt-5 mb-6">
        <h1 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">我的收藏</h1>
        <p className="text-sm text-foreground-600 mt-2">
          共收藏 <strong className="text-primary-600">{items.length}</strong> 部动漫，收藏状态保存在你的浏览器本地。
        </p>
      </header>

      {items.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {items.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      ) : (
        <div className="py-20 text-center bg-background-100 rounded-lg border border-background-200/70">
          <span className="w-16 h-16 mx-auto rounded-full bg-background-50 flex items-center justify-center">
            <i className="ri-heart-3-line text-2xl text-foreground-400" />
          </span>
          <h3 className="font-heading font-semibold text-lg text-foreground-900 mt-4">还没有收藏任何动漫</h3>
          <p className="text-sm text-foreground-500 mt-2">在动漫卡片或详情页点击爱心按钮即可加入收藏</p>
          <Link
            to="/category/hot-blood"
            className="inline-block mt-5 h-10 px-5 leading-10 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600"
          >
            去发现好动漫
          </Link>
        </div>
      )}
    </div>
  );
}